import { Popover, PopoverTrigger } from "@chakra-ui/react";
import { ShareIcon } from "../icons/ShareIcon";
import { SharePopover } from "../buttons/share/SharePopover";
import { usePopoverOpenState } from "../../utils/usePopoverOpenState";
import { KebabContextualMenuItem } from "./KebabContextualMenu";
import { t } from "i18next";

export interface ShareMenuItemProps {
  shareUrl: string;
  shareTitle?: string;
  isLastItem?: boolean;
  popoverPlacement?: "top-start" | "top-end" | "bottom-start" | "bottom-end";
}

export function ShareMenuItem({
  shareUrl,
  shareTitle,
  isLastItem = true,
  popoverPlacement = "top-start",
}: ShareMenuItemProps) {
  const { onToggle, ref, isOpen } = usePopoverOpenState(true);

  const itemTitle =
    shareTitle || t("components.slideInMenu.comicDetailsMenu.share");

  return (
    <Popover isOpen={isOpen} placement={popoverPlacement}>
      <PopoverTrigger>
        <KebabContextualMenuItem
          text={itemTitle}
          icon={
            <ShareIcon
              boxSize="20px"
              transition="inherit"
              _groupHover={{ color: "blaze.blaze" }}
            />
          }
          onClick={onToggle}
          isLastItem={isLastItem}
          ref={ref}
        />
      </PopoverTrigger>
      <SharePopover shareUrl={shareUrl} title={itemTitle} contentRef={ref} />
    </Popover>
  );
}
